import { breakpoints } from "@tvg/design-system";
import styled from "styled-components";

export const Container = styled.div`
  background-color: ${({ theme }) =>
    theme.colorTokens.component.betslip.backgroundExpanded};
  border-radius: 4px 4px 0 0;
  height: 44px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  z-index: 100;

  @media screen and ${breakpoints.tablet.max.sm} {
    border-radius: 0;
  }
`;
